import { callApiToServer } from '../callApi';

export async function sendNotification(
  authtoken,
  messageText,
  messageTitle
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        messageText : messageText,
        titleText : messageTitle
    });
  
    let endUrl = "v1/auth/send-custom-message-to-all-user";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
